import React, { useEffect, useState } from "react";
import "../../assets/css/tables.css";
import "../../assets/scss/result.scss";
import Swal from "sweetalert2";
import deletes from "../../assets/images/tablesImg/delete.png";
import edit from "../../assets/images/tablesImg/edit.png";
import testBluePng from "../../assets/images/notes/notes.svg";
import more_vert from "../../assets/images/home/more_vert.png";
import { useHistory } from "react-router-dom";
import Repository from "../../configs/axios/repository";
import {
    UncontrolledDropdown,
    DropdownMenu,
    DropdownToggle,
    DropdownItem,
} from "reactstrap";
import { useSelector } from "react-redux";
import moment from "moment-timezone";

const ResultTable = ({
    array,
    refreshTable,
    setLoadingData,
    loadingData,
    test_id,
    note_id,
    canDoIt,
    noteData,
    testType,
}) => {
    const history = useHistory();
    const deleteResult = async (id) => {
        const result = await Repository.deleteById(
            `api/resultTest/deleteResultTest/${id}`
        );
        if (result.data?.success == true) {
            refreshTable();
            loadingData
                ? Swal.fire(
                      "Deleted!",
                      "Your file has been deleted.",
                      "success"
                  )
                : "";
        }
    };
    function handleDelete(id) {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.isConfirmed) {
                deleteResult(id);
            }
        });
    }

    function convertToUserTimezone(datetimeString) {
        const specificDateTime = moment(datetimeString, moment.ISO_8601);
        const userTimezone = moment.tz.guess();
        return specificDateTime.tz(userTimezone);
    }
    const thumbs = array?.map((file, i) => {
        return (
            <div key={i} className="notesContent mt-2 resultPadding ">
                <div
                    className="parentCoursesDiv studentInfo"
                    onClick={() => {
                        history.push({
                            pathname: `answers`,
                            state: {
                                test_id,
                                note_id,
                                noteData,
                                canDoIt,
                                testType,
                            },
                            search: `result_test_id=${file.result_test_id}`,
                        });
                    }}
                >
                    <div className="clidrenDivCompakt">
                        <div>
                            <img src={testBluePng} alt="testPng" />
                        </div>
                        <div>
                            <div className="mt-3">
                                {file.name ? <span>{file.name}</span> : ""}
                                <p>
                                    {file.email ? file.email : file.userStatus}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className=" notesFildsParrent">
                    <div className="notesFilds">
                        <div className="resultLogs">
                            {convertToUserTimezone(file.created_at).format(
                                "MMM D, YYYY, HH:mm"
                            )}
                         </div>
                        <div className="resultLogs">
                            {file.test_id.test_type == "written"
                                ? file.score + "/100%"
                                : file.score + "/" + file.question_count}
                        </div>
                    </div>

                    <div className="parentDeleteNote">
                        <UncontrolledDropdown className="dropdown-user nav-item ">
                            <DropdownToggle
                                tag="a"
                                className="nav-link dropdown-user-link "
                            >
                                <img
                                    src={more_vert}
                                    alt="points"
                                    className="pointImg "
                                />
                            </DropdownToggle>
                            <DropdownMenu end>
                                <DropdownItem
                                    onClick={(e) => {
                                        handleDelete(file.result_test_id);
                                    }}
                                >
                                    <div className="actionsMenu actionsMenuContent">
                                        <img src={deletes} alt="deletes" />
                                        <span>Delete</span>
                                    </div>
                                </DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </div>
                </div>
            </div>
        );
    });

    return <div className="divTable mt-4"> {thumbs} </div>;
};

export default ResultTable;
